/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ClientContact } from './ClientContact';
import {
	ClientContactFromJSON,
	ClientContactFromJSONTyped,
	ClientContactToJSON,
} from './ClientContact';
import type { ClientEntity } from './ClientEntity';
import {
	ClientEntityFromJSON,
	ClientEntityFromJSONTyped,
	ClientEntityToJSON,
} from './ClientEntity';

/**
 * Payload of client organization and contact type for client contact
 * @export
 * @interface ClientAndContact
 */
export interface ClientAndContact {
	/**
	 *
	 * @type {ClientEntity}
	 * @memberof ClientAndContact
	 */
	client: ClientEntity;
	/**
	 *
	 * @type {ClientContact}
	 * @memberof ClientAndContact
	 */
	clientContact?: ClientContact;
}

/**
 * Check if a given object implements the ClientAndContact interface.
 */
export function instanceOfClientAndContact(value: object): boolean {
	let isInstance = true;
	isInstance = isInstance && 'client' in value;

	return isInstance;
}

export function ClientAndContactFromJSON(json: any): ClientAndContact {
	return ClientAndContactFromJSONTyped(json, false);
}

export function ClientAndContactFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): ClientAndContact {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		client: ClientEntityFromJSON(json['client']),
		clientContact: !exists(json, 'clientContact')
			? undefined
			: ClientContactFromJSON(json['clientContact']),
	};
}

export function ClientAndContactToJSON(value?: ClientAndContact | null): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		client: ClientEntityToJSON(value.client),
		clientContact: ClientContactToJSON(value.clientContact),
	};
}
